export class FormValidator {
	constructor(formData, fieldsConditions) {
		this.formData = formData;
		this.fieldsConditions = fieldsConditions;
		this.errorConditions = [];
		this.validations = {
			pattern: (fieldValue, fieldCondition, fieldName) => this.validatePattern(fieldValue, fieldCondition, fieldName),
			minLength: (fieldValue, fieldCondition, fieldName) => this.validateMinLength(fieldValue, fieldCondition, fieldName),
			maxLength: (fieldValue, fieldCondition, fieldName) => this.validateMaxLength(fieldValue, fieldCondition, fieldName),
			isRequired: (fieldValue, fieldCondition, fieldName) => this.validateIsRequired(fieldValue, fieldCondition, fieldName),
			matchWith: (fieldValue, fieldCondition, fieldName) => this.validateMatchWith(fieldValue, fieldCondition, fieldName)
		}
		this.validateParams();
	}

	validateParams() {
		Object.keys(this.formData).forEach(fieldName => {
			let fieldsConditions = this.fieldsConditions[fieldName];

			if (!fieldsConditions) {
				console.error(`Field with name: ${fieldName} has missing conditions`)
			}

			Object.keys(fieldsConditions).forEach(condition => {
				const fieldsCondition = fieldsConditions[condition];

				if (!(this.validations[condition] instanceof Function)) {
					console.error(`Condition ${condition} is not implemented for field ${fieldName}`)
				}

				if (fieldsCondition && !fieldsCondition['message']) {
					console.error(`Condition ${condition} has missing message for field ${fieldName}`)
				}

				if (fieldsCondition && !fieldsCondition['value']) {
					console.error(`Condition ${condition} has missing value for field ${fieldName}`)
				}
			})
		})
	}

	validateFormFields() {
		Object.keys(this.formData)
			.forEach(field => {
				this.validateFormField(field);
			})
	}

	validateFormField(fieldName) {
		Object.keys(this.fieldsConditions[fieldName])
			.forEach(conditionName => {
				this.validations[conditionName](this.formData[fieldName], this.fieldsConditions[fieldName][conditionName], fieldName)
			})
	}

	isFieldValid(fieldName) {
		let filter = this.errorConditions.filter(error => error.fieldName === fieldName && !error.fieldCondition.isValid);
		return filter.length === 0;
	}

	validateMatchWith(fieldValue, fieldCondition, fieldName) {
		if (fieldValue) {
			fieldCondition.isValid = fieldCondition.value() === fieldValue;
			this.modifyErrors(fieldCondition, fieldName);
		}
	}

	validatePattern(fieldValue, fieldCondition, fieldName) {
		if (fieldValue) {
			fieldCondition.isValid = !!fieldCondition.value.test(fieldValue);
			this.modifyErrors(fieldCondition, fieldName);
		}
	}

	validateMinLength(fieldValue, fieldCondition, fieldName) {
		fieldCondition.isValid = fieldValue?.length >= fieldCondition.value;
		this.modifyErrors(fieldCondition, fieldName);
	}

	validateMaxLength(fieldValue, fieldCondition, fieldName) {
		if (fieldValue) {
			fieldCondition.isValid = fieldValue.length <= fieldCondition.value;
			this.modifyErrors(fieldCondition, fieldName);
		}
	}

	validateIsRequired(fieldValue, fieldCondition, fieldName) {
		fieldCondition.isValid = !!fieldValue;
		this.modifyErrors(fieldCondition, fieldName);
	}

	modifyErrors(fieldCondition, fieldName) {
		const error = {fieldName, fieldCondition};

		if (fieldCondition.isValid === false) {
			const found = this.errorConditions.filter(item => JSON.stringify(item) === JSON.stringify(error));
			if (found.length === 0) {
				this.errorConditions.push(error)
			}
		} else {
			this.errorConditions = this.errorConditions.filter(item => JSON.stringify(item) !== JSON.stringify(error));
		}
	}

	isFormValid() {
		return this.errors().length === 0;
	}

	errors() {
		return this.errorConditions.filter(error => !error.fieldCondition.isValid)
	}

	reset(fieldsConditions) {
		Object.keys(fieldsConditions).forEach(condition => {
			fieldsConditions[condition].isValid = false;
		})
	}
}

